import { WatchQueryFetchPolicy } from '@apollo/client';
import { Observable } from 'rxjs';

import { PropertyPanelDevice } from '@shure/cloud/shared/models/devices';
import { UpdateResponse } from '@shure/cloud/shared/models/http';
import { DeviceBluetoothPower } from '@shure/shared/angular/data-access/system-api/models';

import {
	AssociateTagMutationResult,
	UpdateChannelAuracastApiInput,
	DissociateTagMutationResult
} from './cloud-device-api.service';

export abstract class DevicePropertyPanelApiService {
	/**
	 * get device by id
	 */
	public abstract getDevice$(deviceId: string, fetchPolicy?: WatchQueryFetchPolicy): Observable<PropertyPanelDevice>;

	/*
	 * forget/unsubscribe to a device
	 */
	public abstract forgetDevice(deviceId: string): void;

	/**
	 * Set mute for a device.
	 */
	public abstract setMute(deviceId: string, mute: boolean): Observable<UpdateResponse<void, string>>;

	/**
	 * Set device name.
	 */
	public abstract setDeviceName(deviceId: string, name: string): Observable<UpdateResponse<void, string>>;

	/**
	 * Set device identifying state.
	 */
	public abstract setIdentify(deviceId: string, identify: boolean): Observable<UpdateResponse<void, string>>;

	/**
	 * Reboot device
	 */
	public abstract rebootDevice(deviceId: string): Observable<UpdateResponse<void, string>>;

	/**
	 * Associate a tag with one or more devices
	 */
	public abstract associateTag(deviceId: string[], tag: string): Observable<AssociateTagMutationResult>;

	/**
	 * Dissociate a tag with one or more devices
	 */
	public abstract dissociateTag(deviceId: string[], tag: string): Observable<DissociateTagMutationResult>;

	/**
	 * Enable or disable IoT Room Proxy
	 */
	public abstract setIotRoomProxy(deviceId: string, enabled: boolean): Observable<UpdateResponse<void, string>>;
	/**
	 * Set Bluetooth power level on a device
	 */
	public abstract setBluetoothPowerLevel(
		deviceId: string,
		level: DeviceBluetoothPower
	): Observable<UpdateResponse<void, string>>;

	/**
	 * Update all Auracast channel settings in a single mutation
	 */
	public abstract updateAuracastChannelSettings(
		input: UpdateChannelAuracastApiInput
	): Observable<UpdateResponse<void, string>>;
}
